import { render, staticRenderFns } from "./PaymentNotReceivedStatus.vue?vue&type=template&id=52329e27&scoped=true"
import script from "./PaymentNotReceivedStatus.vue?vue&type=script&lang=js"
export * from "./PaymentNotReceivedStatus.vue?vue&type=script&lang=js"
import style0 from "./PaymentNotReceivedStatus.vue?vue&type=style&index=0&id=52329e27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52329e27",
  null
  
)

export default component.exports